import { TenantStatus } from '@debbie/common/dist/tenants/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import THEME from '../theme.js';
import Badge from './Badge.js';
const colors = {
    [TenantStatus.Demo]: THEME.COLOR_GREY,
    [TenantStatus.GettingStarted]: THEME.SUCCESS,
    [TenantStatus.Sandbox]: THEME.COLOR_GREY,
    [TenantStatus.Active]: THEME.COLOR_ACCENT,
    [TenantStatus.Disabled]: THEME.DANGEROUS,
};
const TenantStatusBadge = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Badge, { theme: colors[props.status] || THEME.WARNING, style: props.style }, lang.tenantStatus[props.status]));
};
export default TenantStatusBadge;
//# sourceMappingURL=TenantStatusBadge.js.map